import { render } from "./MoldData.vue?vue&type=template&id=53ce6d72&scoped=true"
import script from "./MoldData.vue?vue&type=script&lang=js"
export * from "./MoldData.vue?vue&type=script&lang=js"

import "./MoldData.vue?vue&type=style&index=0&id=53ce6d72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ce6d72"]])

export default __exports__